<template>
  <div class="d-flex align-center justify-center h-screen">
    <p>لطفاً صبر کنید...</p>
  </div>
</template>
